import React, { useState } from "react";
import { AusPostIcon, InhouseParcelIcon } from "../Icon";
import { CustomCellRendererProps } from "ag-grid-react";
import { Box, IconButton, Stack, Typography } from "@mui/material";
import { globalTheme } from "../../styles";
import { InfoOutlined } from "@mui/icons-material";
import { Drawer } from "../Drawer";
import { ShipmentAvailableQuotes } from "../ShipmentAvailableQuotes/ShipmentAvailableQuotes";
import { SelectedQuoteActionButtons } from "../ShipmentsTable/SelectedQuoteActionButtons";

interface PreSelectedQuoteCellProps extends CustomCellRendererProps {
  refreshData: () => void;
  setSnackBar: (snackBar: { open: boolean; message: string; severity: string }) => void;
}

export const OrdersPreSelectedQuoteCell = React.memo((params: PreSelectedQuoteCellProps) => {
  const { data, refreshData, setSnackBar } = params;

  const { selectedQuote } = data;
  // if (!selectedQuote) {
  //   return null; // Or handle this case as needed
  // }

  const [shipmentLogsDrawerOpen, setShipmentLogsDrawerOpen] = useState(false); // State to control drawer

  const handleSelectedQuoteActionButtonsDrawer = () => {
    setShipmentLogsDrawerOpen(false);
    setSnackBar({
      message: "Updated Successfully",
      severity: "success",
      open: true,
    });
    refreshData();
  };

  const handleDrawerOpen = () => {
    setShipmentLogsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setShipmentLogsDrawerOpen(false);
  };

  const getCarrierImage = (courierName) => {
    if (courierName === "EPARCEL") {
      return <AusPostIcon width="25" height="25" />;
    }
    if (courierName === "MYFASTWAY") {
      return (
        <img src="https://vtlogo.com/wp-content/uploads/2021/02/fastway-couriers-vector-logo.png" width="30px" height="24px" />
      );
    }
    if (courierName === "DIRECTFREIGHT") {
      return <img src="https://www.directfreight.com.au/images/logo.gif" width="30px" height="24px" />;
    }
    if (courierName === "INHOUSE" || courierName === "AUSPOST") {
      return <InhouseParcelIcon />;
    }
  };

  return (
    <Stack>
      <Stack direction="row" alignItems="center" spacing={1}>
        <Typography variant="caption">Carrier:</Typography>
        <Typography variant="caption" color={globalTheme.primaryColor}>
          {`${data?.requestedShippingCarrier}`}
        </Typography>

        <Typography variant="caption">Class:</Typography>
        <Typography variant="caption" color={globalTheme.primaryColor}>
          {`${data?.requestedShippingClass}`}
        </Typography>

        {/* Add Icon Button for ShipmentsLogsDrawer */}
        <IconButton size="small" onClick={handleDrawerOpen}>
          <InfoOutlined fontSize="small" sx={{ color: globalTheme.primaryColor }} /> {/* Small shipment icon */}
        </IconButton>
      </Stack>
      {selectedQuote?.shipmentItems.map((item, key) => (
        <Stack key={key} direction="row" alignItems="center" spacing={1}>
          <>{getCarrierImage(selectedQuote?.shippingCarrier)}</>
          <Stack>
            <Stack direction="row" alignItems="center" spacing={1}>
              <Typography variant="body2">Qty:</Typography>
              <Typography variant="body2" color={globalTheme.primaryColor}>
                {item.quantity}
              </Typography>
              ,<Typography variant="body2">Id:</Typography>
              <Typography variant="body2" color={globalTheme.primaryColor}>
                {item.productId}
              </Typography>
              ,<Typography variant="body2">Price:</Typography>
              <Typography variant="body2" color={globalTheme.primaryColor}>
                {item.price}
              </Typography>
            </Stack>
          </Stack>
        </Stack>
      ))}

      <Drawer open={shipmentLogsDrawerOpen} onClose={handleDrawerClose}>
        <Box padding={4}>
          <ShipmentAvailableQuotes data={data} />
        </Box>
        <SelectedQuoteActionButtons data={data} onCloseDrawer={handleSelectedQuoteActionButtonsDrawer} />
      </Drawer>
    </Stack>
  );
});
